<!--
     [isMyProfile]="isMyProfile"
      [page]="selectedPage"
      [user]="user"
      [id]="followersFolloweesId"
   -->
<div style="position: relative; width: 100vw; height: 100vh; background: white;">
  <div class="top-div-holder">
    <div class="top-title" *ngIf="user">{{ user.userName }}</div>
    <div class="page-item-header" (click)="changePage(0)">دنبال‌کننده‌ها</div>
    <div class="page-item-header" (click)="changePage(1)">دنبال‌شده‌ها</div>
    <div class="page-item-indicator" id="hover-tab"></div>
    <div class="back-holder" (click)="goback()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="page-container" *ngIf="dataIsReady">
    <div
      *ngFor="let user of blogUsers; let i = index"
      class="user-box"
      [ngStyle]="{ 'margin-top': i === 0 ? '16px' : '0' }"
    >
      <img
        *ngIf="user.avatarPath !== ''"
        src="{{ user.avatarPath }}"
        onerror="this.onerror=null; this.src='assets/blog/avatar.svg'"
        class="user-img"
        (click)="profile(user.userName)"
      />
      <img
        *ngIf="user.avatarPath === ''"
        src="assets/blog/avatar.svg"
        class="user-img"
        (click)="profile(user.userName)"
      />
      <div class="user-box-username" (click)="profile(user.userName)">
        {{ user.userName }}
      </div>
      <div
        *ngIf="page === 1 && isMyProfile"
        class="unfollow-box"
        (click)="unFollow(user)"
      >
        دنبال شده
      </div>
    </div>
    <div class="more-users" *ngIf="usersCount > (usersPage + 1) * usersPerPage">
      <div class="more-users-title" (click)="showMoreUsers()">
        کاربرهای بیشتر
      </div>
    </div>
  </div>
</div>
